














import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import SimulatorContainer from "@/modules/simulator/containers/SimulatorContainer.vue";
import { SaveStatus, Status } from "@/modules/simulator/store";
import { TITLE } from "../settings";

const { Action, State } = namespace("campos_novos/simulator");

@Component({
    components: {
        SimulatorContainer
    }
})
export default class Simulator extends Vue {
    public loading: boolean = true;

    @State
    public readonly saveStatus!: SaveStatus;

    @State
    public readonly status!: Status;

    @State("is_valid_results")
    public readonly isValidResults!: boolean;

    @Action
    public initialize!: () => Promise<void>;

    public get homeUrlTitle() {
        return TITLE;
    }

    mounted() {
        setTimeout(async () => {
            await this.initialize();
            this.loading = false;
        }, 400);
    }
}
